import { Loading } from '@components/atomic/atoms';
import DebouncedSearchInput from '@components/atomic/molecules/DebouncedSearchInput/DebouncedSearchInput';
import { ArrowDownDark, PlusWhite } from '@icons';
import { getProjects } from '@lib/api';
import { ProjectType } from '@lib/api_ts/projectApi';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react/lib/agGridReact';
import React, { useEffect, useRef, useState, } from 'react';
import { Button, Spinner } from 'react-bootstrap';
// import InfoModal from './EnteEroganteProjectsList/InfoModal';
import { getProjectsTemplate, massImportProjects } from '@lib/api_ts/projectsApi';
import { OETrans } from '@components/translation/OETrans';
import { columnCentered } from '@lib/helpers/agGridHelpers';
import { dateFormatter, formatToDecimals } from '@lib/helpers/formatting';
import { Link } from "react-router-dom"
import EditModal from './EnteEroganteProjectsList/EditModal';
import { MetaType } from '@lib/api_ts/types';

import CustomPagination from '@components/atomic/organisms/ProjectReporting/CustomPagination';
import { RejectModal } from '@components/atomic/organisms';
import SuccessModal from '@components/atomic/organisms/SucessModal/SucessModal';

interface EnteEroganteProjectsListProps {

}

const EnteEroganteProjectsList: React.FC<EnteEroganteProjectsListProps> = () => {
  const gridRef = useRef(null);
  // const [searchTerm, setSearchTerm] = useState('');

  // const defaultPerPage = 100; // Imposta il valore predefinito per perPage
  // const [currentPage, setCurrentPage] = useState(0);
  // const [perPage, setPerPage] = useState(defaultPerPage);

  // useEffect(() => {
  //   setCurrentPage(0);
  //   setPerPage(defaultPerPage);
  //   if (gridRef.current) {
  //     gridRef.current.api.paginationGoToPage(0);
  //     gridRef.current.api.paginationSetPageSize(defaultPerPage);
  //   }
  // }, [searchTerm])

  // console.log('searchTerm', searchTerm);

  const queryClient = useQueryClient();

  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(100);

  const { data: projectsApiResponse, isPending } = useQuery<
    {
      data: ProjectType[], meta: MetaType
    }
  >({
    queryKey: ['projects', currentPage, perPage],
    queryFn: async () => {
      const response = await getProjects(`?page=${currentPage + 1}&perPage=${perPage}`, 'projects');
      return response;
    },
    refetchOnMount: false,
  });

  useEffect(() => {
    if (!projectsApiResponse) return
    setCurrentPage(projectsApiResponse.meta.currentPage - 1);
    setPerPage(projectsApiResponse.meta.perPage);
  }, [projectsApiResponse]);

  const { isFetching: isFetchingTemplate, refetch: refetchTemplate } = useQuery({
    queryKey: ["projects-import"],
    queryFn: async () => {
      const response = await getProjectsTemplate();
      return response;
    },
    enabled: false, // Disabilita il fetch automatico
  })

  const { data: massImportApiResponse, mutate: massImportMutate, isPending: isPendingMassImport, isSuccess: isSuccessMassImport, reset: resetMassImport } = useMutation({
    mutationFn: massImportProjects,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projects'] });
    },
  });

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return
    massImportMutate(file);
    event.target.value = '';
  };

  const columnDefs: ColDef[] = [
    {
      field: 'name',
      headerName: 'Progetto',
      cellRenderer: (params: { data: ProjectType }) => {
        return <Button variant='link' as={Link as any} to={`/project/${params.data.id}/dashboard`} style={{ color: '#1C2743' }}>{params.data.name}</Button>;
      }
    },
    {
      field: 'cup',
      headerName: 'CUP/ID Progetto',


    },
    {
      field: 'notice.call',
      headerName: 'Bando',
    },
    {
      field: "company.name",
      headerName: 'Beneficiario',
    },
    {
      field: 'startDate',
      headerName: 'Avvio',
      ...columnCentered(),
      valueFormatter: (params: { value: string }) => {
        return params.value ? dateFormatter(params.value) : '';
      },
      flex: 0.5,
    },
    {
      field: 'amount',
      headerName: 'Costo €',
      valueGetter: (params) => {
        if (!params.data.totalAmount) return '';
        return formatToDecimals(params.data.totalAmount);
      },
      ...columnCentered(),
    },
    // {
    //   field: 'control',
    //   headerName: 'Attività di Controllo',
    //   ...columnCentered(),

    //   cellRenderer: (params: { data: ProjectType }) => {
    //     console.log('params', params);
    //     return "da campionare"
    //     return <div style={{ fontSize: "18px", lineHeight: '1.95rem' }}>
    //       <div style={{ fontWeight: 700 }}>{"xxx"} completate</div>
    //       <div>{"yyy"} task assegnate a me</div>
    //     </div >
    //   },

    // }
  ];
  const defaultColDef = {
    resizable: true,
    flex: 1,
    wrapText: true,
    autoHeight: true,
    suppressMovable: true,
    cellStyle: {
      paddingLeft: '1rem',
      paddingRight: '1rem',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      color: '#1C2743',
      // display: 'flex',
      // alignItems: 'center',
    },
    // tooltipComponent: CustomTooltip,
    suppressKeyboardEvent: () => {
      // Prevent keyboard events in the grid
      return true;
    },
  };

  return <div className="simple-box scenaritab" style={{ display: "grid", gap: "1.5rem" }}>
    <div
      style={{
        display: "flex", justifyContent: "space-between",
      }}>
      <div style={{ backgroundColor: "#DEE4F1", width: "fit-content", padding: "1.5rem", borderRadius: "8px" }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: "4rem", marginBottom: "1.5rem" }}>
          <h3 style={{
            fontSize: "24px",
            lineHeight: "28px",
            fontWeight: 700,
            marginBottom: 0
          }}>Vuoi aggiungere molti progetti in modo massivo?</h3>
          <div style={{ width: "65.23px" }} />
          {/* <InfoModal /> */}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Button
            onClick={() => {
              refetchTemplate();
            }}
            className='btn custom-outline-button' style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}>
            <span style={{ display: 'inline-flex', width: '1.25rem', height: '1.25rem', alignItems: 'center', justifyContent: 'center' }}>
              {isFetchingTemplate ?
                <Spinner animation="border" role="status" size='sm'>
                  <span style={{ visibility: 'hidden' }}>
                    <OETrans code="common.loading" fallback={'Caricamento'} />
                    ...
                  </span>
                </Spinner>
                : <ArrowDownDark />}
            </span>
            Scarica il template excel
          </Button>
          <Button
            onClick={() => { fileInputRef.current?.click() }}
            className='btn custom-ghost-button' style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}>
            <span style={{ display: 'inline-flex', width: '1.25rem', height: '1.25rem', alignItems: 'center', justifyContent: 'center' }}>
              {isPendingMassImport ?
                <Spinner animation="border" role="status" size='sm'>
                  <span style={{ visibility: 'hidden' }}>
                    <OETrans code="common.loading" fallback={'Caricamento'} />
                    ...
                  </span>
                </Spinner>
                : <ArrowDownDark style={{ rotate: '180deg' }} />}
            </span>


            Carica il template compilato
          </Button>
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: "none" }}
            accept=".csv,.xlsx,.xls" // opzionale: tipi di file supportati
          />
        </div>
      </div>

      <SuccessModal
        show={isSuccessMassImport && massImportApiResponse?.success === true}
        onHide={resetMassImport}
        message="Import massivo completato con successo." />

      <RejectModal
        show={isSuccessMassImport && massImportApiResponse?.success === false}
        onHide={resetMassImport}
        message={massImportApiResponse?.error || "Non è stato possibile importare massivamente i progetti."}
        tryAgain={() => massImportMutate(fileInputRef.current?.files?.[0])} />

      <div style={{ marginTop: "auto", display: "flex", gap: "1rem" }}>
        <EditModal
          type="create"
          trigger={
            <Button
              className='btn custom-primary-button'
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                fontWeight: 500
              }}>
              <PlusWhite /> Nuovo progetto
            </Button>
          } />
        <DebouncedSearchInput onSearchTermChange={(term) => {
          if (!gridRef.current) return;
          gridRef.current.api.setQuickFilter(term);
        }} />
      </div>
    </div>
    {isPending ? <Loading /> :
      <>
        <div className="ag-theme-alpine list-table">
          <AgGridReact ref={gridRef}
            columnDefs={columnDefs}
            rowData={projectsApiResponse.data}
            defaultColDef={defaultColDef}
            domLayout="autoHeight"
          // rowHeight={80}
          />
        </div>
        <CustomPagination
          count={projectsApiResponse.meta.total || 0}
          currentPage={currentPage}
          gridRef={gridRef}
          loading={isPending}
          perPage={perPage}
          setCurrentPage={setCurrentPage}
          setPerPage={setPerPage}
        />
      </>
    }

  </div>
}

export default EnteEroganteProjectsList